import Vue from 'vue'
// import VueStickyKit from './stickykit.js'
import VueLocalStorage from 'vue-localstorage'
import axios from 'axios'
import * as Cookies from 'js-cookie'
var qs = require('qs')
var _ = require('lodash')
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '../css/global.css'
var SocialSharing = require('vue-social-sharing')
import Vuelidate from 'vuelidate'
import Vue2TouchEvents from 'vue2-touch-events'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { VueContext } from 'vue-context'
import ApolloClient from 'apollo-boost'
import VueApollo from 'vue-apollo'
import { Base64 } from 'js-base64'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { persistCache } from 'apollo-cache-persist'
import stripHtml from "string-strip-html"
const truncate = require('truncate')
var URLSearchParams = require('url-search-params')
let urlParams = new URLSearchParams(window.location.search)
import 'unfetch/polyfill'
import * as localForage from "localforage"

//const cache = new InMemoryCache()

const apolloProvider = new VueApollo({
  defaultClient: new ApolloClient({
    //cache,
    headers: {
      'X-CSRFToken': Cookies.get('csrftoken')
    }
  })
})

Vue.filter('striphtml', function (value) {
  if (!value) return ''
  return stripHtml(value)
})

Vue.filter('truncate300', function (value) {
  if (!value) return ''
  return truncate(value, 300)
})

Vue.filter('truncate150', function (value) {
  if (!value) return ''
  return truncate(value, 150)
})

Vue.use(VueApollo)
Vue.use(BootstrapVue)
// Vue.use(VueStickyKit)
Vue.directive('stick-in-parent', {
  bind: function(el, binding) {
    window.jQuery = window.jQuery || require('jquery');
    require('sticky-kit/dist/sticky-kit.js');
    window.jQuery(document).ready(function () {
      var sticky = binding.value || {};
      var options = sticky.options || {};
      var events = sticky.on || {};
      window.jQuery(el).stick_in_parent(options);
      for (var i in events) {
        window.jQuery(el).on(i, events[i]);
      }
    })
  }
})
Vue.use(SocialSharing)
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true //created computed members from your variable declarations
})
Vue.use(Vuelidate)
Vue.use(Vue2TouchEvents, {
    disableClick: true
})

Vue.prototype.$qs = qs
Vue.prototype.$lodash = _
Vue.prototype.$cookies = Cookies
Vue.prototype.$base64 = Base64
Vue.prototype.$http = axios.create({
  headers: {'X-CSRFToken': Cookies.get('csrftoken')}
})

export default {
  apolloProvider,
  data () {
    return {
      cacheLoaded: false,
      alerts: [],
      isLoading: false,
      'window': window,
      quantities: {},
      tileSizes: {},
      colorLookups: [],
      quantityUpdated: true,
      productMegaMenuShow: false,
      exploreMegaMenuShow: false,
      shopMegaMenuShow: false,
      residentialSwitch: true,
      showSearchInput: false,
      commercialSwitch: null,
      localBookmarkedTiles: [],
      localBookmarkedSeries: [],
      bookmarked_series: [],
      bookmarked_tiles: [],
      bookmarked_sampleorder_skus: [],
      bookmarked_comparisons: [],
      sampleOrders: [],
      compare1Data: null,
      compare2Data: null,
      compare3Data: null,
      compare4Data: null,
      windowData: {
        width: 0,
        height: 0
      },
      stopSlider: false,
      pinterestImage: '',
      pinterestNote: '',
      pinterestLink: '',
      modalShow: false
    }
  },
  destroyed() {
     window.removeEventListener('resize', this.handleResize)
   },
  components: {
      Loading,
      VueContext,
  },
  async created () {
    //JSON.parse(this.$ls.get('residential_switch', 'false'))
    //this.commercialSwitch = JSON.parse(this.$ls.get('commercial_switch', 'true'))
    this.reloadLocalBookmarks()
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    // if (!this.$ls.get('residential_switch', false) && !this.$ls.get('commercial_switch', false) && window.location.pathname != '/florida-tile-appreciation-drawing/' && window.location.pathname != '/careers/' && !urlParams.has('promo')) {
    //   this.modalShow = true
    // }
    // await before instantiating ApolloClient, else queries might run before the cache is persisted
    //await persistCache({
      //cache,
      //storage: localForage,
    //})
    this.cacheLoaded = true
  },
  methods: {
    async clearApolloCache() {
      localForage.clear()
      const client = this.$apollo.getClient()
      await client.resetStore()
    },
    decodeRelayID (relay_id) {
      return Base64.decode(relay_id).split(':')[1]
    },
    encodeTileID (id) {
      return Base64.encode(`TileGraph:${id}`)
    },
    encodeSeriesID (id) {
      return Base64.encode(`SeriesGraph:${id}`)
    },
    handleResize() {
       this.windowData.width = window.innerWidth
       this.windowData.height = window.innerHeight
    },
    makeProductMegaMenuShow () {
      this.exploreMegaMenuShow = false
      this.shopMegaMenuShow = false
      if (this.productMegaMenuShow) {
        this.productMegaMenuShow = false
      } else {
        this.productMegaMenuShow = true
      }
    },
    makeExploreMegaMenuShow () {
      this.productMegaMenuShow = false
      this.shopMegaMenuShow = false
      if (this.exploreMegaMenuShow) {
        this.exploreMegaMenuShow = false
      } else {
        this.exploreMegaMenuShow = true
      }
    },
    makeShopMegaMenuShow () {
      this.productMegaMenuShow = false
      this.exploreMegaMenuShow = false
      if (this.shopMegaMenuShow) {
        this.shopMegaMenuShow = false
      } else {
        this.shopMegaMenuShow = true
      }
    },
    productMegaMenuHide () {
      setTimeout(() => {
        this.productMegaMenuShow = false
      }, 0.9)
    },
    exploreMegaMenuHide () {
      setTimeout(() => {
        this.exploreMegaMenuShow = false
      }, 0.9)
    },
    shopMegaMenuHide () {
      setTimeout(() => {
        this.shopMegaMenuShow = false
      }, 0.9)
    },
    reloadLocalBookmarks() {
      this.localBookmarkedSeries = JSON.parse(this.$ls.get('bookmarked_series_ids', '[]'))
      this.localBookmarkedTiles = JSON.parse(this.$ls.get('bookmarked_tile_ids', '[]'))
    },
    isSeriesBookmarked(id) {
      let local_bookmarked_series = JSON.parse(this.$ls.get('bookmarked_series_ids', '[]'))
      if (_.includes(local_bookmarked_series, id)) {
        return true
      } else {
        return false
      }
    },
    isTileBookmarked(id) {
      let local_bookmarked_tiles = JSON.parse(this.$ls.get('bookmarked_tile_ids', '[]'))
      if (_.includes(local_bookmarked_tiles, id)) {
        return true
      } else {
        return false
      }
    },
    isProductSKUCompared(sku) {
      let local_bookmarked_comparisons = JSON.parse(this.$ls.get('bookmarked_comparison_skus', '[]'))
      if (_.includes(local_bookmarked_comparisons, sku)) {
        return true
      } else {
        return false
      }
    },
    addSeriesBookmark(id) {
      let local_bookmarked_series = JSON.parse(this.$ls.get('bookmarked_series_ids', '[]'))
      if (!_.includes(local_bookmarked_series, id)) {
        local_bookmarked_series.push(id)
        this.$ls.set('bookmarked_series_ids', JSON.stringify(Array.from(new Set(local_bookmarked_series))))
        this.reloadLocalBookmarks()
        this.addAlert('Successfully added a new bookmark!', 'success')
      } else {
        local_bookmarked_series.splice(local_bookmarked_series.findIndex(x => x==id), 1)
        this.$ls.set('bookmarked_series_ids', JSON.stringify(Array.from(new Set(local_bookmarked_series))))
        this.reloadLocalBookmarks()
        this.addAlert('Successfully removed a bookmark!', 'success')
      }
    },
    addTileBookmark(id) {
      let local_bookmarked_tiles = JSON.parse(this.$ls.get('bookmarked_tile_ids', '[]'))
      if (!_.includes(local_bookmarked_tiles, id)) {
        local_bookmarked_tiles.push(id)
        this.$ls.set('bookmarked_tile_ids', JSON.stringify(Array.from(new Set(local_bookmarked_tiles))))
        this.reloadLocalBookmarks()
        this.addAlert('Successfully added a new bookmark!', 'success')
      } else {
        local_bookmarked_tiles.splice(local_bookmarked_tiles.findIndex(x => x==id), 1)
        this.$ls.set('bookmarked_tile_ids', JSON.stringify(Array.from(new Set(local_bookmarked_tiles))))
        this.reloadLocalBookmarks()
        this.addAlert('Successfully removed a bookmark!', 'success')
      }
    },
    addSampleOrderSKU(id, event) {
      if(event){
        event.preventDefault()
      }
      window.location.href = "/sample-information";
      // let local_bookmarked_sample_orders = JSON.parse(this.$ls.get('bookmarked_sampleorder_skus', '[]'))
      // let count = 1
      // if (this.totalSamples >= 5) {
      //   this.addAlert('Only five sample orders may be selected!', 'danger')
      //   return false
      // } else if(local_bookmarked_sample_orders.includes(id)){
      //   this.addAlert('This item as already been selected', 'danger')
      //   return false
      // } else {
      //   local_bookmarked_sample_orders.unshift(id)
      //   this.bookmarked_sampleorder_skus = local_bookmarked_sample_orders
      //   this.$ls.set('bookmarked_sampleorder_skus', JSON.stringify(Array.from(new Set(local_bookmarked_sample_orders))))
      //   this.addAlert('Successfully added a new sample order!', 'success')
      //   return true
      // }
    },
    addProductComparisonSKU(sku) {
      if (!this.isProductSKUCompared(sku)) {
        let local_bookmarked_comparisons = JSON.parse(this.$ls.get('bookmarked_comparison_skus', '[]'))
        if (local_bookmarked_comparisons.length >= 4) {
          this.addAlert('Only four products may be compared!', 'danger')
        } else {
          local_bookmarked_comparisons.push(sku)
          this.$ls.set('bookmarked_comparison_skus', JSON.stringify(Array.from(new Set(local_bookmarked_comparisons))))
          this.loadComparisons()
          this.addAlert('Successfully added a new product to be compared!', 'success')
        }
      } else {
        this.removeProductComparisonSKU(sku)
      }
    },
    shareToPinterest(image, note, link, event) {
      this.pinterestImage = image
      this.pinterestNote = note
      this.pinterestLink = link
      this.$refs.imageContextMenu.open(event)
    },
    sendPin() {
       PDK.pin(this.pinterestImage, this.pinterestNote, this.pinterestLink)
    },
    addAlert(message, type) {
      this.alerts.push({
        'message': message,
        'type': type
      })
    },
    // setResidential() {
    //   if (this.residentialSwitch) {
    //     this.residentialSwitch = false
    //     this.commercialSwitch = true
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //     // this.addAlert('The commercial filter is now active!', 'success')
    //   } else {
    //     this.residentialSwitch = true
    //     this.commercialSwitch = false
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //     // this.addAlert('The residential filter is now active!', 'success')
    //   }
    // },
    // setCommercial() {
    //   if (this.commercialSwitch) {
    //     this.residentialSwitch = true
    //     this.commercialSwitch = false
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //     // this.addAlert('The residential filter is now active!', 'success')
    //   } else {
    //     this.residentialSwitch = false
    //     this.commercialSwitch = true
    //     this.$ls.set('residential_switch', this.residentialSwitch)
    //     this.$ls.set('commercial_switch', this.commercialSwitch)
    //     // this.addAlert('The commercial filter is now active!', 'success')
    //   }
    // },
    setResidentialModal() {
      this.residentialSwitch = true
      this.commercialSwitch = false
      this.$ls.set('residential_switch', this.residentialSwitch)
      this.$ls.set('commercial_switch', this.commercialSwitch)
      // this.addAlert('The residential filter is now active!', 'success')
    },
    setCommercialModal() {
      this.residentialSwitch = false
      this.commercialSwitch = true
      this.$ls.set('residential_switch', this.residentialSwitch)
      this.$ls.set('commercial_switch', this.commercialSwitch)
      // this.addAlert('The commercial filter is now active!', 'success')
    },
    addSampleOrderSKUBookmarks (object) {
      //this.addSampleOrderSKU(object)
      if (this.bookmarked_sampleorder_skus.length < 5) {
        this.bookmarked_sampleorder_skus.push(object)
      }
    },
    async loadBookmarks () {
      this.bookmarked_series_ids = JSON.parse(this.$ls.get('bookmarked_series_ids', '[]'))
      this.bookmarked_tiles_ids = JSON.parse(this.$ls.get('bookmarked_tile_ids', '[]'))
      this.bookmarked_sampleorder_skus = JSON.parse(this.$ls.get('bookmarked_sampleorder_skus', '[]'))
      this.quantities = JSON.parse(this.$ls.get('bookmarked_sampleorder_quantities', '{}'))
/*      local_bookmarked_series.forEach(async (el, index, the_array) => {
        try {
          let response = await this.$http.post('/api/public/v1/', {
            'action': 'get_series_data',
            'series': el
          })
          this.bookmarked_series.push(response.data.data)
        }
        catch (error) {
          console.log(error)
        }
      })
      local_bookmarked_tiles.forEach(async (el, index, the_array) => {
        try {
          let response = await this.$http.post('/api/public/v1/', {
            'action': 'get_tile_data',
            'tile': el
          })
          this.bookmarked_tiles.push(response.data.data)
        }
        catch (error) {
          console.log(error)
        }
      })
      local_bookmarked_sample_orders.forEach(async (el, index, the_array) => {
        try {
          let response = await this.$http.post('/api/public/v1/', {
            'action': 'get_tile_data',
            'tile': el
          })
          this.bookmarked_sampleorder_skus.push(response.data.data)
        }
        catch (error) {
          console.log(error)
        }
      })*/
    },
    removeSeriesBookmark (id) {
      let index = this.bookmarked_series_ids.indexOf(id)
      this.bookmarked_series_ids.splice(index, 1)
      console.log(this.bookmarked_series_ids)
      this.localBookmarkedSeries = this.bookmarked_series_ids
      this.$ls.set('bookmarked_series_ids', JSON.stringify(Array.from(new Set(this.bookmarked_series_ids))))
      this.addAlert('Successfully removed a bookmark!', 'success')
/*      
      let bookmarked_series_ids = []
      this.bookmarked_series.splice(id, 1)
      this.bookmarked_series.forEach((el) => {
        bookmarked_series_ids.push(el.id)
      })
      this.$ls.set('bookmarked_series_ids', JSON.stringify(Array.from(new Set(bookmarked_series_ids))))
      this.addAlert('Successfully removed a bookmark!', 'success')*/
    },
    removeTileBookmark (id) {
      let index = this.bookmarked_tiles_ids.indexOf(id)
      this.bookmarked_tiles_ids.splice(index, 1)
      this.localBookmarkedTiles = this.bookmarked_tiles_ids
      this.$ls.set('bookmarked_tile_ids', JSON.stringify(Array.from(new Set(this.localBookmarkedTiles))))
      this.addAlert('Successfully removed a bookmark!', 'success')
/*      let bookmarked_tile_ids = []
      this.bookmarked_tiles_ids.splice(id, 1)
      this.bookmarked_tiles.forEach((el) => {
        bookmarked_tile_ids.push(el)
      })
      this.$ls.set('bookmarked_tile_ids', JSON.stringify(Array.from(new Set(bookmarked_tile_ids))))
      this.addAlert('Successfully removed a bookmark!', 'success')*/
    },
    removeSampleOrderSKU (id) {
      let index = this.bookmarked_sampleorder_skus.indexOf(id)
      this.bookmarked_sampleorder_skus.splice(index, 1)
      this.$ls.set('bookmarked_sampleorder_skus', JSON.stringify(Array.from(new Set(this.bookmarked_sampleorder_skus))))
      this.addAlert('Successfully removed a sample order SKU!', 'success')
/*      let local_bookmarked_sampleorder_skus = []
      this.bookmarked_sampleorder_skus.splice(id, 1)
      this.bookmarked_sampleorder_skus.forEach((el) => {
        local_bookmarked_sampleorder_skus.push(el.sku)
      })
      this.$ls.set('bookmarked_sampleorder_skus', JSON.stringify(Array.from(new Set(local_bookmarked_sampleorder_skus))))
      this.addAlert('Successfully removed a sample order SKU!', 'success')*/
    },
    removeProductComparisonSKU (sku) {
      let local_bookmarked_comparisons = JSON.parse(this.$ls.get('bookmarked_comparison_skus', '[]'))
      local_bookmarked_comparisons.splice(local_bookmarked_comparisons.indexOf(sku), 1)
      this.$ls.set('bookmarked_comparison_skus', JSON.stringify(Array.from(new Set(local_bookmarked_comparisons))))
      if (local_bookmarked_comparisons.length == 0) {
        this.compare1Data = null
      }
      this.loadComparisons()
      this.addAlert('Successfully removed a product!', 'success')
    },
    removeAllSeriesBookmarks () {
      this.bookmarked_series = [] 
      this.localBookmarkedSeries = []
      this.$ls.remove('bookmarked_series_ids')
      this.addAlert('All series bookmarks have been cleared!', 'success')
    },
    removeAllSampleOrderSKUs () {
      this.bookmarked_sampleorder_skus = [] 
      this.$ls.remove('bookmarked_sampleorder_skus')
      this.addAlert('All sample SKUs have been cleared!', 'success')
    },
    removeAllTileBookmarks () {
      this.bookmarked_tiles = [] 
      this.localBookmarkedTiles = []
      this.$ls.remove('bookmarked_tile_ids')
      this.addAlert('All tile bookmarks have been cleared!', 'success')
    },
    removeAllProductComparisonSKU () {
      this.bookmarked_comparisons = [] 
      this.$ls.remove('bookmarked_comparison_skus')
      this.compare1Data = null
      this.compare2Data = null
      this.compare3Data = null
      this.compare4Data = null 
      this.loadComparisons()
      this.addAlert('All product comparisons have been cleared!', 'success')
    },
    addSampleToCart(tileObject, override = false) {
      this.quantities = JSON.parse(this.$ls.get('bookmarked_sampleorder_quantities', '{}'))
      if (_.find(this.sampleOrders, { 'sku': tileObject.sku }) === undefined) {
        if (this.totalSamples < 5 || override === true) {
          if (this.quantities[tileObject.sku]) {
            tileObject.quantity = this.quantities[tileObject.sku]
          }
          else {
            tileObject.quantity = 1
          }
          this.colorLookups.push(tileObject.color.id)
          this.sampleOrders.push(tileObject)
          this.selectedSeries1 = ''
          this.selectedSeries1SKU = ''
        }
        else {
          this.addAlert('You can only order up to 5 samples!', 'danger')
        }
      }
      else {
        this.addAlert('This tile is already in the sample order queue!', 'danger')
      }
      this.quantityUpdated = true
    },
    saveQuantities() {
      let data = {}
      for (const sampleOrder of this.sampleOrders) {
        data[sampleOrder.sku] = sampleOrder.quantity
      }
      this.$ls.set('bookmarked_sampleorder_quantities', JSON.stringify(data))
    },
    loadComparisons () {
      try {
        this.isLoading = true
        this.compare2Data = null
        this.compare3Data = null
        this.compare4Data = null 
        let local_bookmarked_comparisons = JSON.parse(this.$ls.get('bookmarked_comparison_skus', '[]'))
        if (local_bookmarked_comparisons.length > 0) {
          local_bookmarked_comparisons.forEach(async (e, index) => {
            switch (index) {
              case 0:
                let response = await this.$http.post('/api/public/v1/', {
                  action: 'get_tile_data',
                  tile: null,
                  sku: e
                })
                this.compare1Data = response.data.data
                break
              case 1:
                let response2 = await this.$http.post('/api/public/v1/', {
                  action: 'get_tile_data',
                  tile: null,
                  sku: e
                })
                this.compare2Data = response2.data.data
                break
              case 2:
                let response3 = await this.$http.post('/api/public/v1/', {
                  action: 'get_tile_data',
                  tile: null,
                  sku: e
                })
                this.compare3Data = response3.data.data
                break
              case 3:
                let response4 = await this.$http.post('/api/public/v1/', {
                  action: 'get_tile_data',
                  tile: null,
                  sku: e
                })
                this.compare4Data = response4.data.data
                break
            }
          })
          // this.addAlert('Product comparison data has been loaded!', 'success')
        } else {
          // this.addAlert('You have not yet added any products to be compared!', 'danger')
        }
        this.isLoading = false
      } catch (error) {
        console.log(error)
        this.isLoading = false
        this.addAlert('There was an error loading comparison data!', 'danger')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./core/vue/js/global_mixins.js